import React from "react";
import { useState, useEffect } from "react";
import "../RegistroUsuario/RegistroUsuario.css";
import { userOrder } from '../../states/userOrder';
import { configShop } from '../../states/configShop';
import Modal from "../Modal/modal";
import AddressAdd from "../Address/AddressAdd";
import ShopAdd from "../Address/ShopAdd";
import useWindowWidth from "../hooks/useMediaQuery";
import { FaMap, FaEdit, FaStore, FaMotorcycle } from "react-icons/fa";
import { FaCalendarCheck } from "react-icons/fa6"
import PopUpProgramarNew from "../DetallePago/PopUpProgramarNew";
import { getShopId } from "../../utils/shopValidation";
import { directionsLink } from "../../utils/pickup";
const DeliveryMethods = () => {
    const { dataConfig } = configShop();
    const width = useWindowWidth();
    const btnColor = dataConfig?.page_menu?.button?.color      ?? "#000";
    const btnText  = dataConfig?.page_menu?.button?.color_text ?? "#fff";
    const { setDataUser, dataUser } = userOrder();
    const [openModal, setOpenModal] = useState(false);
    const [openShop, setOpenShop] = useState(false);
    //
    const [popUpFechaEntrega, setpopUpFechaEntrega] = useState(false);
    // PLZ-325: en "Pide y Recoge" el metodo siempre es recoger.
    useEffect(() => {
        if (dataUser.pickupOnly === true && Number(dataUser.deliveryMethod) !== 2) {
            setDataUser({ deliveryMethod: 2 });
        }
    }, [dataUser.pickupOnly, dataUser.deliveryMethod, setDataUser]);
    // Recoger en tienda sin sede (o con la sede guardada descartada): se pide escoger de nuevo.
    useEffect(() => {
        if (Number(dataUser.deliveryMethod) === 2 && !getShopId(dataUser.shopData)) {
            setOpenShop(true);
        }
    }, [dataUser.deliveryMethod, dataUser.shopData]);
    function isPastDelivery(dateDelivery) {
        if (!dateDelivery) return true;

        // Convertir string a Date local
        const [datePart, timePart] = dateDelivery.split(" ");
        const [year, month, day] = datePart.split("-").map(Number);
        const [hour, minute] = timePart.split(":").map(Number);

        const deliveryDate = new Date(
            year,
            month - 1,
            day,
            hour,
            minute
        );

        const now = new Date();

        return deliveryDate <= now;
    }
    const editStyle = { color: btnColor, display: "flex", alignItems: "center", gap: "4px", fontSize: "13px", fontWeight: 600 };
    // PLZ-325: entrada por "Pide y Recoge": solo recoger, sin selector de domicilio.
    const pickupOnly = dataUser.pickupOnly === true;
    const comoLlegar = directionsLink(dataUser.shopData);

    return (
        <div className="App">

            {!pickupOnly && (
            <div className="container-info-orden">
                {dataConfig.order && (
                    <button
                        onClick={() => { setOpenShop(true); setOpenModal(false); }}
                        className={`botton-type-delivery ${dataUser.deliveryMethod === 2 ? "botton-type-delivery-select" : ""}`}
                        style={{ "--btn-color": btnColor, "--btn-text-color": btnText }}
                    >
                        <FaStore style={{ marginRight: "6px" }} /> Recoger en tienda
                    </button>
                )}
                {dataConfig.delivery && (
                    <button
                        onClick={() => { setOpenShop(false); setOpenModal(true); }}
                        className={`botton-type-delivery ${dataUser.deliveryMethod === 1 ? "botton-type-delivery-select" : ""}`}
                        style={{ "--btn-color": btnColor, "--btn-text-color": btnText }}
                    >
                        <FaMotorcycle style={{ marginRight: "6px" }} /> Domicilio
                    </button>
                )}
            </div>
            )}

            {dataUser.deliveryMethod === 1 ? (
                <section className="container-sub-titulos" onClick={() => setOpenModal(true)}>
                    <div className="container-agregar-tarjeta" style={{ width: "100%", justifyContent: "space-between" }}>
                        <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                            <FaMap color={btnColor} /> {dataUser.address}, {dataUser.city_name}
                        </span>
                        <span style={editStyle}>Editar <FaEdit /></span>
                    </div>
                </section>
            ) : pickupOnly ? (
                <section className="container-sub-titulos">
                    <div className="container-agregar-tarjeta" style={{ width: "100%", justifyContent: "space-between", alignItems: "flex-start" }}>
                        <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                            <span style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "12px", color: "#666" }}>
                                <FaStore color={btnColor} /> Recoges en
                            </span>
                            <span style={{ fontWeight: 600 }}>{dataUser.shopData?.name || "Elige la sede"}</span>
                            {dataUser.shopData?.name && (
                                <span style={{ fontSize: "12px", color: "#666" }}>{dataUser.shopData.address}, {dataUser.shopData.city}</span>
                            )}
                            {dataUser.shopData?.name && comoLlegar && (
                                <a href={comoLlegar} target="_blank" rel="noopener noreferrer" style={{ ...editStyle, textDecoration: "none", marginTop: "4px" }}>
                                    <FaMap /> Cómo llegar
                                </a>
                            )}
                        </div>
                        <span style={{ ...editStyle, cursor: "pointer" }} onClick={() => setOpenShop(true)}>Cambiar sede <FaEdit /></span>
                    </div>
                </section>
            ) : (
                <section className="container-sub-titulos" onClick={() => setOpenShop(true)}>
                    <div className="container-agregar-tarjeta" style={{ width: "100%", justifyContent: "space-between" }}>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <span style={{ fontWeight: 600 }}>{dataUser.shopData?.name || "Selecciona una tienda"}</span>
                            {dataUser.shopData?.name && (
                                <span style={{ fontSize: "12px", color: "#666" }}>{dataUser.shopData.address}, {dataUser.shopData.city}</span>
                            )}
                        </div>
                        <span style={editStyle}>Editar <FaEdit /></span>
                    </div>
                </section>
            )}

            <section className="container-sub-titulos" onClick={() => setpopUpFechaEntrega(true)}>
                <div className="container-agregar-tarjeta" style={{ width: "100%", justifyContent: "space-between" }}>
                    <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <FaCalendarCheck color={btnColor} />
                        {pickupOnly ? "Listo para recoger:" : "Entrega:"} <b>{isPastDelivery(dataUser.dateDelivery) ? (pickupOnly ? "Lo antes posible" : "Llevar ahora") : dataUser.dateDelivery}</b>
                    </span>
                    <span style={editStyle}>Editar <FaEdit /></span>
                </div>
            </section>
            <Modal
                h={"auto"}
                w={width > 768 ? "60%" : "90%"}
                isOpen={openModal}
                onClick={() => setOpenModal(false)}
                title={"Datos de entrega."}
            >
                <AddressAdd
                    setOpenModal={setOpenModal}
                />
            </Modal>
            <Modal
                h={"auto"}
                w={width > 768 ? "60%" : "90%"}
                isOpen={openShop}
                onClick={() => setOpenShop(false)}
                title={pickupOnly ? "Elige la sede donde recoges" : "Seleccione Tienda"}
            >
                <ShopAdd
                    setOpenModal={setOpenShop}
                />
            </Modal>
            <PopUpProgramarNew
                popUpFechaEntrega={popUpFechaEntrega}
                setpopUpFechaEntrega={setpopUpFechaEntrega}
                propiedadesCompany={dataUser}
                color_botton={dataConfig?.color_botton}
                btnTextColor={dataConfig?.color_button_text}
            />
        </div >
    );
};
export default DeliveryMethods;
